import React from "react";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2, MapPin } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export function ShippingAddressList({ addresses, onEdit, onDelete }) {
  if (!addresses || addresses.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        No hay direcciones de envío registradas
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nombre</TableHead>
          <TableHead>Dirección</TableHead>
          <TableHead>Ciudad</TableHead>
          <TableHead>Provincia</TableHead>
          <TableHead>CP</TableHead>
          <TableHead>Teléfono</TableHead>
          <TableHead>Acciones</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {addresses.map((address) => (
          <TableRow key={address.id}>
            <TableCell className="font-medium">
              {address.name}
              {address.is_default && (
                <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                  Por defecto
                </span>
              )}
            </TableCell>
            <TableCell>{address.street}</TableCell>
            <TableCell>{address.city}</TableCell>
            <TableCell>{address.province}</TableCell>
            <TableCell>{address.postal_code}</TableCell>
            <TableCell>{address.phone}</TableCell>
            <TableCell onClick={(e) => e.stopPropagation()}>
              <div className="flex space-x-2">
                <Button
                  variant="outline"
                  size="icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onEdit(address);
                  }}
                >
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button
                  variant="destructive"
                  size="icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDelete(address.id);
                  }}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
} 